export const CRYPTO_CURRENCYS = {
  USDTRC: 'USDTTRC20',
  USDTERC: 'USDTERC20',
  USDTBEP: 'USDTBEP20',
  BTC: 'BTC',
  ETH: 'ETH'
}

export const CRYPTO_CURRENCYS_USDT = {
  USDTRC: 'USDTTRC20',
  USDTERC: 'USDTERC20',
  USDTBEP: 'USDTBEP20'
}

export const CRYPTO_CURRENCYS_FORMATED = {
  USDTRC: 'USDT TRC20',
  USDTERC: 'USDT ERC20',
  USDTBEP: 'USDT BEP20'
}

export const GREY_ASSETS = ['USDTTRC20D', 'USDTERC20D', 'USDTBEP20D']

export const TOKEN_NETWORK_SUFFIXES = ['TRC20', 'ERC20', 'BEP20']

export const PREFERRED_ASSET_CODES = [
  'USDTTRC20', 'USDTERC20', 'USDTBEP20',
  'USDCTRC20', 'USDCERC20', 'USDCBEP20'
]

// Keep the incoming order for assets outside the preferred list.
export function sortAssetCodes (codes) {
  return (codes || [])
    .map((code, index) => ({code, index}))
    .sort((a, b) => {
      const aPriority = PREFERRED_ASSET_CODES.indexOf(a.code)
      const bPriority = PREFERRED_ASSET_CODES.indexOf(b.code)
      const aOrder = aPriority === -1 ? PREFERRED_ASSET_CODES.length : aPriority
      const bOrder = bPriority === -1 ? PREFERRED_ASSET_CODES.length : bPriority
      return aOrder - bOrder || a.index - b.index
    })
    .map(item => item.code)
}

// Deposit addresses are per-network; /create_wallet responds with these keys
export const QR_KEY_BY_NETWORK = {
  TRC20: 'TRC',
  ERC20: 'ERC',
  BEP20: 'BEP'
}

const TOKEN_CODE_RE = new RegExp(`^(.+?)(${TOKEN_NETWORK_SUFFIXES.join('|')})(D?)$`)

// 'USDCERC20' → 'ERC20', 'USDTTRC20D' → 'TRC20' (grey), 'BTC' → null
export function getTokenNetwork (code) {
  if (!code) return null
  const clean = String(code).replace(/D$/, '')
  return TOKEN_NETWORK_SUFFIXES.find(suffix => clean.endsWith(suffix)) || null
}

// Any actionable network token (TRC20/ERC20/BEP20), not just USDT.
// Grey (D-suffixed) variants are display-only and are rejected here.
export function isNetworkToken (code) {
  if (!code || String(code).endsWith('D')) return false
  return getTokenNetwork(code) !== null
}

// Crypto assets of the deposit/withdraw flows: BTC, ETH and every network token
export function isCryptoToken (code) {
  return code === CRYPTO_CURRENCYS.BTC || code === CRYPTO_CURRENCYS.ETH || isNetworkToken(code)
}

// Display-oriented check: like isCryptoToken but also matches grey variants —
// use for rounding/formatting of amounts, not for gating flows
export function isCryptoAsset (code) {
  return code === CRYPTO_CURRENCYS.BTC || code === CRYPTO_CURRENCYS.ETH || getTokenNetwork(code) !== null
}

// 'USDCERC20' → 'USDC ERC20' ('USDCERC20D' → 'USDC ERC20D'); non-network codes are returned as is
export function formatTokenCode (code) {
  const match = code ? String(code).match(TOKEN_CODE_RE) : null
  return match ? `${match[1]} ${match[2]}${match[3]}` : code
}

// Display form for transaction lists: spaced, grey suffix stripped —
// 'USDCERC20D' → 'USDC ERC20' (grey-ness is conveyed by row styling)
export function formatTokenDisplay (code) {
  const match = code ? String(code).match(TOKEN_CODE_RE) : null
  return match ? `${match[1]} ${match[2]}` : code
}

// Wallet-address validation rules are registered per legacy USDT code
// (validator.js); every token of a network shares its address format
export function addressRuleFor (code) {
  const network = getTokenNetwork(code)
  if (network === 'TRC20') return CRYPTO_CURRENCYS.USDTRC
  if (network === 'ERC20') return CRYPTO_CURRENCYS.USDTERC
  if (network === 'BEP20') return CRYPTO_CURRENCYS.USDTBEP
  return code
}

export const AML = [
  'Risk score',
  'ATM',
  'Child exploitation',
  'Dark market',
  'Dark service',
  'Enforcement action',
  'Exchange fraudulent',
  'Exchange licensed',
  'Exchange unlicensed',
  'Gambling',
  'Illegal service',
  'Liquidity pools',
  'Marketplace',
  'Miner',
  'Mixer',
  'Other',
  'P2P exchange licensed',
  'P2P exchange unlicensed',
  'Payment',
  'Ransom',
  'Sanctions',
  'Scam',
  'Seized assets',
  'Stolen coins',
  'Terrorism financing',
  'Wallet'
]



// WEBPACK FOOTER //
// ./src/js/utils/consts.js